
export default class ImportCsvData
{
    id = 0;
    isSelected = false;
    isMetaDataOnly= false;
    ISBN =''
    Title=''
    Author=''
    Summary=''
    Thumbnail=''
    Publisher=''
    CityOfPublication=''
    CountryOfPublication=''
    PublishedYear=''
    PublishedYear=''
    isImported=''
    keywords=''
    listprice=''
    discount=''
    countries_allowed=''
    bisac=''
    lcc=''
    dewey=''
    language=''
    contributorRole1=''
    contributor1=''
    contributorRole2=''
    contributor2=''
    contributorRole3=''
    contributor3=''
    contributorRole4=''
    contributor4=''
    contributorRole5=''
    contributor5=''
    contributorRole6=''
    contributor6=''
    contributorRole7=''
    contributor7=''
    contributorRole8=''
    contributor8=''
    contributorRole9=''
    contributor9=''
    contributorRole10=''
    contributor10=''
}


// WEBPACK FOOTER //
// ./src/model/ImportCsvData.js